import React, {
    Suspense,
    useContext,
    useEffect,
    useState,
} from 'react';

import {
    Route,
    Routes,
    useLocation,
} from 'react-router-dom';

import { Loader } from '../components/Loader';
import { PopupOverlay } from '../components/PopupOverlay';
import { GlobalStyles } from '../global';
import {
    ApiContext,
    CoreContext,
    FirebaseContext,
} from '../providers';
import { Article } from './Article';
import DebtRegistryAuth from './DebtRegistryAuth';
import NotFound from './NotFound';
import { Page } from './Page';

export const Router = () => {
    const { settings } = useContext(CoreContext);
    const { Storyblok, getRequestID } = useContext(ApiContext);
    const { popupComponent } = useContext(CoreContext);
    const { getCurrentUser } = useContext(FirebaseContext);

    const [ready, setReady] = useState(false);
    const location = useLocation();

    console.log('Onescore integrated')

    useEffect(() => {
        Promise.all([
            /**
             * When the environment is running on development mode
             * (localhost mostly) we would like to get `staging` strings from
             * Storyblok. We are using staging version because offical /
             * production strings are likely to change overtime. That scenerio
             * would break E2E tests that rely on the text.
             */
            sessionStorage.setItem('version', settings.languageVersion),

            Storyblok.getStoryblokContent(),

            getCurrentUser(),
            getRequestID(),
        ]).then(() => {
            setReady(true);
        });
    }, []);

    /**
     * Scrolls page smoothly to very top when page route changes,
     * also scrolls page to #id
     */
    useEffect(() => {
        if (location.hash) {
            let element = document.getElementById(location.hash.slice(1));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
    }, [location]);

    if (!ready) {
        return <Loader centered />;
    }

    /**
     * TODO: Remove process-request and admin authentication once these will
     * be moved to admin page logic.
     */
    return (
        <Suspense fallback={<Loader centered />}>
            <GlobalStyles />
            <Routes>
                <Route path="/blog/:articleSlug" element={<Article />} />

                <Route path="/" element={<Page />}>
                    <Route path=":slug" element={<Page />} />
                    <Route path="/altinn/*" element={<Page />} />
                    <Route path="/process/:slug" element={<Page />} />
                </Route>
                <Route
                    path="/auth/redirect/debtregistry"
                    element={<DebtRegistryAuth />}
                />

                <Route element={<NotFound />} />
            </Routes>
            {popupComponent && <PopupOverlay>{popupComponent}</PopupOverlay>}
        </Suspense>
    );
};
